enum TaxiCargoContractListingBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export default TaxiCargoContractListingBillingModel;
